<div class="container">
  <div class="content">
    <ng-container>
      <p class="export-attributes">Export Attributes</p>

      <div class="ea-list">
        @for (item of entity.exportAttributes; track item; let i = $index) {
          <div class="content-column">
            <div class="row">
              <coin-dropdown
                label="Level *"
                placeholder="Level"
                [items]="LEVEL"
                [(ngModel)]="item.level"
                (selectionChange)="onSelect($event, i)"></coin-dropdown>
              <coin-v2-text-input
                [placeholder]="'Key'"
                [label]="'Key *'"
                [errorMessage]="validateKey(item.key)"
                [(ngModel)]="item.key"></coin-v2-text-input>
              <coin-v2-text-input
                [placeholder]="'Value'"
                [label]="'Value *'"
                [(ngModel)]="item.value"></coin-v2-text-input>
              <ng-container>
                <i
                  class="material-icons delete-button"
                  (click)="remove(i)">
                  delete
                </i>
              </ng-container>
            </div>
          </div>
        }
      </div>

      <ng-container>
        <div style="width: 100%; display: flex; justify-content: center">
          <coin-icon-button
            type="primary"
            icon="add"
            (click)="add()" />
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
